import {
  requestCustomerPrivacyBlob,
  requestCustomerPrivacyJson,
} from './customerPrivacyApi.request'
import type {
  CustomerPrivacyDashboard,
  CustomerPrivacyExportCreateResponse,
  CustomerPrivacyExportStatusResponse,
} from './customerPrivacyApi.types'

export * from './customerPrivacyApi.types'
export { CustomerPrivacyApiError } from './customerPrivacyApi.request'

export const fetchCustomerPrivacyDashboard = (token?: string | null) =>
  requestCustomerPrivacyJson<CustomerPrivacyDashboard>(
    '/account/privacy',
    {
      method: 'GET',
    },
    token,
  )

export const createCustomerPrivacyExportRequest = (token?: string | null) =>
  requestCustomerPrivacyJson<CustomerPrivacyExportCreateResponse>(
    '/account/privacy/export',
    {
      method: 'POST',
      body: '{}',
    },
    token,
  )

export const fetchCustomerPrivacyExportRequestStatus = (
  requestId: string,
  token?: string | null,
) =>
  requestCustomerPrivacyJson<CustomerPrivacyExportStatusResponse>(
    `/account/privacy/export/${encodeURIComponent(requestId)}`,
    {
      method: 'GET',
    },
    token,
  )

export const updateCustomerPrivacyConsents = (
  input: {
    marketingEmail?: boolean
    promotionalNotifications?: boolean
  },
  token?: string | null,
) =>
  requestCustomerPrivacyJson<{ consents: CustomerPrivacyDashboard['consents'] }>(
    '/account/privacy/consents',
    {
      method: 'PATCH',
      body: JSON.stringify(input),
    },
    token,
  )

export const requestCustomerAccountDeletion = (password: string, token?: string | null) =>
  requestCustomerPrivacyJson<{
    requestId: string
    status: 'completed'
    accountStatus: 'anonymized'
    completedAt: string
  }>(
    '/account/privacy/delete',
    {
      method: 'POST',
      body: JSON.stringify({ password }),
    },
    token,
  )

export const downloadCustomerPrivacyExport = async ({
  token,
  downloadUrl,
}: {
  token?: string | null
  downloadUrl: string
}) => {
  const blob = await requestCustomerPrivacyBlob({ token, downloadUrl })
  return blob
}
